export default __webpack_public_path__ + "static/media/favicon.6b3f952f.ico";